// import moveFeatures from "../../../lib-utils/move-features";

export const createTCDirectSelectMode = MapboxDraw => {
  const TCDirectSelect = {};

  // TCDirectSelect.dragFeature = function(state, e, delta) {
  //   console.log("drag feature state --- ", state);
  //   console.log("drag feature e --- ", e);
  //   console.log("drag feature delta --- ", delta);

  //   moveFeatures(this.getSelected(), delta);
  //   state.dragMoveLocation = e.lngLat;
  // };

  return { ...MapboxDraw.modes.direct_select, ...TCDirectSelect };
};
